import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import TextGradient from "@app/components/gradient/gradient-text"
import { useThemeContext } from "@app/contexts/theme-context"
import { useState } from "react"

const MobileHealthcare = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { isTablet } = useThemeContext();

  return (
    <div className="flex items-center">
      <div
        className="h-full w-full bg-cover bg-top bg-no-repeat"
        style={{
          backgroundImage: isTablet ? "url('/images/industries/healthcare.png')" :
            "url('/images/industries/mobile-healthcare.png')",
        }}
      >
        <div className="flex flex-col bg-opacity-60 blur-content bg-light px-8 py-6  md:space-y-3 space-y-1 xs:space-y-2">
          <div className="flex flex-col md:space-y-3 space-y-2">
            <TextGradient>
              <span className="h2">05</span>
            </TextGradient>
            <p className="mobile-h3 2xs:mobile-h2 text-background-primary-dark pb-4">Healthcare</p>
            <GradientContainer overrideClassName="w-[30%] h-2" />
            <div className="text-body-lg 2xs:text-base space-y-2 pt-4 xs:space-y-5">
              <p className="text-text-color-mid-em">
                SimpleWaste represents all healthcare facility types with emphasis
                on the specialized management of all
                healthcare-unique waste profiles.
              </p>
              <p className="text-text-color-mid-em">
                Our service model and technology platform provides cost reduction with 100% transparency.
                We&apos;ve designed our platf orm to benefit single units, multiple locations,
                and IDNs, with 24/7 access to live data, billing and compliance reports.
              </p>
              {isExpanded && (
                <div className="space-y-5 text-text-color-mid-em">
                  <p>
                    SimpleWaste&apos;s unique technology platform provides key functionality to
                    support your specialized waste and recycling programs.
                    Our Sole Source User Interface provides unlimited integration across
                    multiple facility types and operations for detailed waste profile
                    management and connected workflow.
                  </p>
                  <p>
                    We keep your operations team up to speed with KPI and data metrics
                    specific to the healthcare industry.
                  </p>
                  <p>
                    At SimpleWaste we design effective solutions that flow seamlessly
                    within your operational footprint.
                  </p>
                </div>
              )}
            </div>
            <div className="pt-2">
              <Button onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? 'Read less' : 'Read more'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileHealthcare;